var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock_close_round [#707]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-103.000000, -5079.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,4936.00046 C59,4936.55246 58.552,4937.00046 58,4937.00046 L50,4937.00046 C49.448,4937.00046 49,4936.55246 49,4936.00046 L49,4928.00046 C49,4927.44846 49.448,4927.00046 50,4927.00046 L58,4927.00046 C58.552,4927.00046 59,4927.44846 59,4928.00046 L59,4936.00046 Z M52,4923.00046 C52,4921.89746 52.897,4921.00046 54,4921.00046 C55.103,4921.00046 56,4922.00046 56,4923.00046 L56,4925.00046 L52,4925.00046 L52,4923.00046 Z M58,4925.00046 L58,4923.00046 C58,4920.75346 55.739,4918.50546 53.164,4919.09546 C51.266,4919.53046 50,4921.34146 50,4923.28846 L50,4925.00046 L49,4925.00046 C47.895,4925.00046 47,4925.89546 47,4927.00046 L47,4937.00046 C47,4938.10546 47.895,4939.00046 49,4939.00046 L59,4939.00046 C60.105,4939.00046 61,4938.10546 61,4937.00046 L61,4927.00046 C61,4925.89546 60.105,4925.00046 59,4925.00046 L58,4925.00046 Z",
    id: "lock_close_round-[#707]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "res/media/lock.e9e7478e09648cf81a4e19c4d0dd4320.svg";
export { ForwardRef as ReactComponent };